export default __webpack_public_path__ + "static/media/SwooshClipped.e4b57d0a.mp3";